var _excluded = ["isOpen", "onClose", "size", "children", "isLoading", "shouldHideCloseButton", "closeButtonAriaLabel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Modal as ChakraModal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { forwardRef } from 'react';
import { Portal } from '../../../components/internal';
import { useBreakpoint } from '../../../theme';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { BottomSheet } from '../../BottomSheet';
import { LoadingContainer } from '../../LoadingContainer';
import { BaseModalContext } from './BaseModalContext';
import { BaseModalCloseButton } from './components';
import { useScrollBorders } from './useScrollBorders';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BaseModal = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
    isOpen,
    onClose,
    size = 'small',
    children,
    isLoading,
    shouldHideCloseButton,
    closeButtonAriaLabel
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    isExtraSmallScreen: isMobile
  } = useBreakpoint();
  var {
    showBorderTop,
    showBorderBottom
  } = useScrollBorders();
  var styles = useMultiStyleConfig('BaseModal', {
    size,
    isLoading,
    shouldHideCloseButton,
    showBorderTop,
    showBorderBottom
  });
  return /*#__PURE__*/_jsx(BaseModalContext.Provider, {
    value: {
      shouldHideCloseButton
    },
    children: isMobile ? /*#__PURE__*/_jsx(BottomSheet, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref,
      isOpen: isOpen,
      onClose: onClose,
      showCloseButton: !shouldHideCloseButton,
      isLoading: isLoading,
      closeButtonAriaLabel: closeButtonAriaLabel,
      children: children
    })) : /*#__PURE__*/_jsx(ChakraModal, {
      isOpen: isOpen,
      onClose: onClose,
      isCentered: true,
      size: "unset",
      children: /*#__PURE__*/_jsxs(Portal, {
        children: [/*#__PURE__*/_jsx(ModalOverlay, {}), /*#__PURE__*/_jsxs(ModalContent, _objectSpread(_objectSpread({
          "data-component": "BaseModal",
          ref: ref
        }, props), {}, {
          sx: styles['modalContent'],
          children: [!shouldHideCloseButton && /*#__PURE__*/_jsx(BaseModalCloseButton, {
            closeButtonAriaLabel: closeButtonAriaLabel
          }), isLoading ? /*#__PURE__*/_jsx(LoadingContainer, {
            isLoading: true
          }) : children]
        }))]
      })
    })
  });
});
BaseModal.displayName = 'BaseModal';
//# sourceMappingURL=BaseModal.js.map